export default {
  compatibleChargersTitle: 'Understøttede ladebokse',
  smartChargeSupport: 'Saving Mode virker med ladebokse fra blandt andre Zaptec og NexBlue.',
  smartChargeWorksVia: 'Forbind din ladeboks i enkel-appen. Vi understøtter blandt andet Zaptec og NexBlue.',
  chooseElAftaleHere: 'Vælg din elaftale her',
  heroTitle1: 'Ladeboks og elaftale',
  heroTitle2: 'til skarpe priser',
  heroTitle1Full: 'Ladeboks og elaftale',
  heroSubtitle: 'Find en ladeboks til hjemmet, og vælg den elaftale, der passer til dig.',
  heroNote: '*Har du allerede en ladeboks?',
  heroNoteLink: 'Se vores elaftaler',
  seeChargers: 'Se ladebokse',
  chooseCharger: 'Vælg din ladeboks',
  compatibleNote: 'Alle vores ladebokse understøtter Saving Mode',
  alreadyHaveCharger: 'Har du allerede en',
  compatibleChargers: 'understøttet ladeboks',
  chooseElHere: 'Vælg din elaftale her',
  selectCharger: 'Vælg ladeboks',
  seeOtherChargers: 'Se andre ladebokse',
  priceFrom: 'Fra',
  plusElAftale: '+ elaftale fra 0,72 kr./kWh',
  badgeFutureProof: 'Forberedt til fremtiden',
  badgeReliable: 'Pålidelig',
  badgePremium: 'Premium',
  feature22kw: 'Op til 22 kW ladeeffekt',
  featureWifiBluetooth: 'Wi-Fi og Bluetooth',
  featureWifi4g: 'Wi-Fi- og 4G-forbindelse',
  featureRfid: 'RFID-adgangskontrol',
  feature5YearWarranty: '5 års producentgaranti',
  featureV2x: 'Forberedt til V2X',
  featureV2g: 'Teknologi forberedt til V2G',
  featureLoadBalancing: 'Dynamisk lastbalancering',
  featureIp54: 'Vejrbestandig med IP54',
  featureSolar: 'Solcelleintegration',
  keySpecs: 'Specifikationer',
  maxPower: 'Maks. effekt',
  years: 'år',
  warranty: 'Garanti',
  features: 'Funktioner',
  smartChargeIncluded: 'Saving Mode inkluderet',
  smartChargeDesc: 'Prisgaranti på opladning: Du betaler prisen for de billigste timer i ladeperioden. Inkluderet i alle elaftaler.',
  spotPriceExcludes: 'Spotpris ekskl. abonnement, netbetaling, afgifter og moms',
  chargingPower: 'Op til {power} ladeeffekt',
  connectivity: 'Forbindelse',
  warrantyYears: '5 års producentgaranti',
  weatherproof: 'Vejrbestandig med IP54',
  v2xReady: 'Forberedt til V2X',
  v2gReady: 'Teknologi forberedt til V2G',
  solarIntegration: 'Solcelleintegration',
  rfidAccess: 'RFID-adgangskontrol',
  dynamicLoadBalancing: 'Dynamisk lastbalancering',
  processTitle: 'Fra valg af ladeboks til opladning derhjemme',
  processSubtitle: 'Vælg din ladeboks, installation og elaftale. Vi hjælper dig i gang.',
  step1Title: 'Vælg din ladeboks',
  step1Text: 'Sammenlign modellerne, og find den, der passer til dit hjem.',
  step2Title: 'Vælg installation',
  step2Text: 'Få ladeboksen installeret af en autoriseret elektriker.',
  step3Title: 'Vælg din elaftale',
  step3Text: 'Strøm til hele hjemmet og opladningen af din elbil.',
  faqTitle: 'Spørgsmål om ladebokse og elaftaler',
  faq1Q: 'Hvad koster en ladeboks med elaftale?',
  faq1A: 'Ladeboksen koster fra 3.999 kr. Hertil kommer eventuel installation og din elaftale med en elpris fra 0,72 kr./kWh. Du kan se pris og vilkår, før du bestiller.',
  faq2Q: 'Er der abonnement på elaftalen?',
  faq2A: 'Ja. Du betaler abonnement på din elaftale og for den strøm, du bruger. Se priser og afregningsformer under vores elaftaler.',
  faq3Q: 'Kan jeg købe ladeboks og elaftale sammen?',
  faq3A: 'Ja. Du kan vælge en ladeboks, eventuel installation og en elaftale til hjemmet i samme bestilling.',
  faq4Q: 'Hvad får jeg med en ladeboks og elaftale?',
  faq4A: 'Du får en ladeboks til hjemmeopladning og en elaftale, der dækker både hjemmet og elbilen. Strømforbruget afregnes efter din valgte elaftale.',
  finalCtaTitle: 'Klar til at lade derhjemme?',
  finalCtaSubtitle: 'Vælg ladeboks, installation og elaftale, så det passer til dig.',
  onlyElAftale: 'Kun elaftale',
  exclusiveEnkel: 'fra enkel energi',
  bestPriceDkExclusiveEnkel: 'Skarpt tilbud fra enkel energi',
  result: 'Resultat:',
  danmarksBilligste: 'Skarp pris',
  cheapestSolution: 'billigste ladeløsning',
  testOf14: 'Test af 14 udbydere',
  januar2026: 'Januar 2026',
  latestRecognition: 'Seneste anerkendelser',
  nicolaskjText1: 'enkel energi placeres som',
  nicolaskjText2: 'elselskab i en uafhængig analyse uden affiliatelinks.',
  elbiilText1: 'enkel energi kåret som',
  elbiilText2: 'i Danmark – laveste pris på el og service.',
};